import { SharedButton } from "@components";
import { IClient, IProfile } from "@interfaces";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
interface IProps {
  data?: IClient;
  serviceCategory?: string;
}
export const ClientInformation = ({ data, serviceCategory }: IProps) => {
  const { t } = useTranslation();
  return (
    <StyledInner>
      <header>
        <h5>{t("page.patient_information")}</h5>
      </header>
      <StyledList>
        <ItemRow label={t("page.name")} value={data?.name || t("page.empty")} />
        <ItemRow
          label={t("page.age")}
          value={dayjs().diff(data?.dateOfBirth, "years") || t("page.empty")}
        />
        <ItemRow label={t("page.service_category")} value={serviceCategory || "---"} />        
        <ItemRow label={t("page.insulinType")} value={data?.insulinType || ""} />
        <ItemRow label={t("page.hospital_name")} value={data?.hospitalName || "---"} />
        <ItemRow label={t("page.contact_phonenumber")} value={data?.phoneNumber || "---"} />
      </StyledList>
    </StyledInner>
  );
};
interface IItemRow {
  label: string;
  value: string | number;
}
const StyledList = styled.div`
  width: 100%;
`;
const ItemRow = ({ label, value }: IItemRow) => {
  return (
    <StyledItem>
      <p className="label">{label}</p>
      <p className="value">{value}</p>
    </StyledItem>
  );
};
const StyledItem = styled.article`
  padding: 22px 14px;
  border-bottom: 1px solid #d9d9d9;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .label {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    color: #6f7482;
  }
  .value {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    text-align: right;
    color: #2a2d34;
  }
`;

const StyledInner = styled.section`
  max-width: 600px;
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  align-items: center;
  header {
    display: flex;
    justify-content: center;
    align-items: center;
    h5 {
      font-weight: 700;
      font-size: 18px;
      line-height: 25px;
      display: flex;
      align-items: center;
      color: #2a2d34;
    }
  }
`;
